import React, { useCallback } from "react"
import { Link, Redirect, useHistory, useLocation } from "react-router-dom"

import { Formik, Form } from "formik"
import { Fieldset } from "components"

import * as yup from "yup"

import { useAuth } from "hooks/useAuth"

const loginModel = {
  // email: "arsenijesavic@me.com",
  // password: "Brate13!",
  // password: "Brate13",

  email: "",
  password: "",
}

const loginSchema = yup.object().shape({
  email: yup
    .string()
    .email("Please provide valid email address")
    .required("Email is required!"),
  password: yup.string().required("Password is required"),
})

const Page = ({ children }) => (
  <div className="w-full min-h-screen flex justify-center items-center">
    {children}
  </div>
)

const LoginPage = () => {
  const { user, signInWithEmailAndPassword } = useAuth()
  const location = useLocation()
  const { from } = location.state || { from: { pathname: "/" } }

  const formikProps = {
    initialValues: { ...loginModel },
    validateOnBlur: false,
    validateOnChange: false,
    validationSchema: loginSchema,
    onSubmit: useCallback(async (values, { setSubmitting, setFieldError }) => {
      try {
        await signInWithEmailAndPassword(values)
      } catch (error) {
        console.error(error)
        setSubmitting(false)
        if (error.message) {
          setFieldError("server", error.message)
        } else {
          setFieldError("server", "Something went wrong.")
        }
      }
    }),
  }

  if (user) return <Redirect to={from.pathname} />

  return (
    <Page>
      <Formik {...formikProps}>
        {({ errors, isSubmitting }) => (
          <Form className="w-full h-full">
            <div className="max-w-sm mx-auto bg-white shadow-lg p-6 py-10 relative z-50 rounded-lg">
              <header className="text-center mb-6">
                <h1 className="text-xl text-gray-900 leading-none">
                  Welcome back!
                </h1>

                <p className="text-sm text-gray-500 leading-normal mt-2">
                  Login by entering the email and password
                </p>
              </header>

              <div className="py-3">
                <Fieldset name="email" label="Email" type="email" />
              </div>

              <div className="py-3">
                <Fieldset name="password" label="Password" type="password" />
              </div>

              <div class="flex items-center justify-between pb-3">
                <div class="flex items-center">
                  {/* <input
                    id="remember_me"
                    name="remember_me"
                    type="checkbox"
                    class="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                  />
                  <label
                    for="remember_me"
                    class="ml-2 block text-sm text-gray-900"
                  >
                    Remember me
                  </label> */}
                </div>

                <div class="text-sm">
                  <Link
                    to="/forgot-password"
                    className="font-medium text-indigo-600 hover:text-indigo-500"
                  >
                    Forgot your password?
                  </Link>
                </div>
              </div>

              {errors && errors.server && (
                <div className=" text-sm error bg-red-200 text-red-800 p-2 mt-2">
                  {errors.server}
                </div>
              )}

              <button
                disabled={isSubmitting}
                type="submit"
                class="mt-6 group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-wait"
              >
                <span class="absolute left-0 inset-y-0 flex items-center pl-3">
                  <svg
                    class="h-5 w-5 text-indigo-500 group-hover:text-indigo-400"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </span>
                Login
              </button>
            </div>
          </Form>
        )}
      </Formik>

      <div className="absolute inset-0">
        <img
          className="w-full h-full object-cover"
          src="/images/s-migaj-Yui5vfKHuzs-unsplash.jpg"
          alt=""
        />
      </div>
    </Page>
  )
}

export default LoginPage
